export default __webpack_public_path__ + "static/media/lisa.97977d43.JPG";